import React from 'react';
import {formatCurrency} from '~/utils';
import '../style/BillPrint.scss';

const BillPrint = React.forwardRef(({billData}, ref) => {
    const {
        code,
        date,
        cashier,
        customer,
        items,
        subtotal,
        totalVat,
        discountAmount,
        discountType,
        discount,
        total,
        paid,
        change
    } = billData;

    return (
        <div ref={ref} className="bill-print">
            <div className="bill-container">
                {/* Header */}
                <div className="bill-header">
                    <div className="store-name">PHIẾU BÁN HÀNG</div>
                    <div className="store-info">Website: giochatuyet.com</div>
                    <div className="store-info">ĐC: 330 Bùi Hữu Nghĩa, Gia Định, Bình Thạnh</div>
                    <div className="store-info">Ngày : {date}</div>
                </div>
                {/* Bill Info */}
                <div className="bill-info">
                    <div className="info-row">
                        <span>Đơn hàng:</span>
                        <span>{code}</span>
                    </div>
                    {customer && (
                        <div className="info-row">
                            <span>Khách hàng:</span>
                            <span>{customer}</span>
                        </div>
                    )}
                    <div className="info-row">
                        <span>Nhân viên:</span>
                        <span>{cashier}</span>
                    </div>
                </div>

                <div className="bill-divider">---------------------------</div>

                {/* Items */}
                <div className="bill-items">
                    {items && items.map((item, index) => {
                        // Calculate item total based on unit
                        const itemTotal = item.unit === 'kg'
                            ? item.price * item.quantity * 10
                            : item.price * item.quantity;

                        // Calculate display quantity (convert back from grams if needed)
                        const displayQuantity = item.unit === 'kg'
                            ? (item.quantity / 1000).toFixed(2)
                            : item.quantity;

                        return (
                            <div key={index} className="bill-item">
                                <div className="item-name">
                                    {item.title || item.name}
                                    {item.attribute_label && <span className="item-variant"> ({item.attribute_label})</span>}
                                </div>
                                <div className="item-detail">
                                    <span className="item-qty">
                                        {displayQuantity} {item.unit} x {formatCurrency(item.price)}
                                    </span>
                                    <span className="item-total">
                                        {formatCurrency(itemTotal)}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="bill-divider">---------------------------</div>

                {/* Summary */}
                <div className="bill-summary">
                    <div className="summary-row">
                        <span>Tạm tính:</span>
                        <span>{formatCurrency(subtotal)}</span>
                    </div>
                    {totalVat > 0 && (
                        <div className="summary-row">
                            <span>VAT:</span>
                            <span>{formatCurrency(totalVat)}</span>
                        </div>
                    )}
                    {discountAmount > 0 && (
                        <div className="summary-row">
                            <span>
                                Chiết khấu {discountType === 'percent' ? ` (${discount}%)` : ''}:
                            </span>
                            <span>-{formatCurrency(discountAmount)}</span>
                        </div>
                    )}

                    <div className="summary-row total-row">
                        <span>Tổng:</span>
                        <span>{formatCurrency(total)}</span>
                    </div>

                    <div className="summary-row">
                        <span>Khách đưa:</span>
                        <span>{formatCurrency(paid)}</span>
                    </div>
                    <div className="summary-row">
                        <span>Thối lại:</span>
                        <span>{formatCurrency(change)}</span>
                    </div>
                </div>
                {/* Footer */}
                <div className="bill-footer">
                    <div className="thank-you">Cam on quy khach!</div>
                    <div className="visit-again">Hen gap lai!</div>
                </div>
            </div>
        </div>
    );
});

BillPrint.displayName = 'BillPrint';

export default BillPrint;
